import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StarRatingClickEvent } from '../star-rating/models/starRatingClickEvent';
import { AttributeDefinitionValueListItem } from 'src/app/shared/models/attributes/attributeDefinitionValueListItem';

@Component({
  selector: 'app-star-rating-attribute',
  templateUrl: './star-rating-attribute.component.html',
  styleUrls: ['./star-rating-attribute.component.scss'],
  standalone: false
})
export class StarRatingAttributeComponent {
  @Input() starRatings: AttributeDefinitionValueListItem[] = [];
  @Input() editMode = false;
  @Input() selectedStarRating: AttributeDefinitionValueListItem;

  @Output() selectedChanged = new EventEmitter<AttributeDefinitionValueListItem>();
  hoveredStarRating: AttributeDefinitionValueListItem;

  constructor() {}

  onMouseLeave(): void {
    this.hoveredStarRating = null;
  }

  getItemDescription(starRating: AttributeDefinitionValueListItem): string {
    return starRating
      ? starRating.itemValue === '0'
        ? 'Not applicable'
        : starRating.itemDescription
      : '';
  }

  getItemRank(starRating: AttributeDefinitionValueListItem): number {
    return starRating ? starRating.rank : 0;
  }

  getStaticColor(starRating: AttributeDefinitionValueListItem): string {
    if (starRating == null || starRating.rank === 0) {
      return 'default';
    } else {
      return 'ok';
    }
  }

  onStarRatingClickChange(event: StarRatingClickEvent): void {
    this.selectedStarRating = this.starRatings[event.rating];
    this.selectedChanged.emit(this.selectedStarRating);
  }

  onStarRatingHoverChange(event: StarRatingClickEvent): void {
    this.hoveredStarRating = this.starRatings[event.rating];
  }
}
